import { useState } from 'react'
import { Navigation, Thumbs } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useMediaQuery } from 'usehooks-ts'



import useGalleryModal from '@features/gallery/hooks/useGalleryModal'
import { useGalleryStore } from '@features/gallery/model/useGallery'

import { cn } from '@shared/lib/cn'
import ButtonClose from '@shared/ui/button-close'
import ImageWithBg from '@shared/ui/image-with-bg'

import styles from './styles.module.scss'

import type { Swiper as SwiperType } from 'swiper'




export default function Gallery () {
  const isTablet = useMediaQuery('(max-width: 991px)')
  const [ thumbsSwiper, setThumbsSwiper ] = useState<SwiperType | null>(null)
  const { images } = useGalleryStore()
  const { closeGalleryModal } = useGalleryModal()

  return (
    <div className={styles.root}>
      <ButtonClose className={styles.root__close} onClick={closeGalleryModal} />

      <div className={styles.root__main}>
        <Swiper
          className={cn('_navigation-center', '_navigation-rect')}
          modules={[ Thumbs, Navigation ]}
          navigation={!isTablet}
          thumbs={{ swiper: thumbsSwiper }}
          spaceBetween={20}
        >
          {images?.map((item, index) => (
            <SwiperSlide key={index}>
              <ImageWithBg className={styles['root__main-photo']} src={item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className={styles.root__thumbs}>
        <Swiper
          onSwiper={setThumbsSwiper}
          spaceBetween={8}
          slidesPerView="auto"
          watchSlidesProgress
          className={styles['root__thumbs-swiper']}
        >
          {images?.map((item, index) => (
            <SwiperSlide key={index} className={styles['root__thumbs-slide']}>
              <ImageWithBg className={styles['root__thumbs-img']} src={item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
}
